import React from "react";
import { FilterDatePicker } from "@/pages/received-data/filter-date-picker";
import PropTypes from "prop-types";
import MultiSelectCheckbox from "@/components/MultiSelectCheckbox/index";
import DatePicker from "@/components/DatePicker/index";
const MultiSelectFilter = ({
	filterConfig,
	statusOptions,
	setStatusOptions,
	startDate,
	setStartDate,
	endDate,
	setEndDate,
	resetFilter,
	disableFilters,
}) => {
	return (
		<div className="overview_filter overview-filter__full-width">
			<div className="overview_filter__cols overview-filter__flex">
				{filterConfig?.map((option, index) => {
					return (
						<div key={option?.id} className="overview_filter__col">
							<div className="overview_filter__col__top overview_filter__col__title">
								{option.title}
							</div>
							<div className="overview_filter__col__bottom">
								<MultiSelectCheckbox
									items={option?.props?.items}
									onChangeFunc={option?.props?.onChangeFunc}
									disable={option?.props?.disable}
								/>
							</div>
						</div>
					);
				})}
				<div className="overview_filter__col">
					<div className="overview_filter__col__top overview_filter__col__title">
						Start Date
					</div>
					<div className="overview_filter__col__bottom">
						<DatePicker
							selectDate={startDate}
							setSelectDate={setStartDate}
							placeHolderText="Select date and time"
							disable={disableFilters}
						/>
					</div>
				</div>
				<div className="overview_filter__col">
					<div className="overview_filter__col__top">&nbsp;</div>
					<div className="overview_filter__col__bottom overview_filter__col__bottom--padding-top-bottom">
						–
					</div>
				</div>
				<div className="overview_filter__col">
					<div className="overview_filter__col__top">End Date</div>
					<div className="overview_filter__col__bottom">
						<FilterDatePicker
							endDate={endDate}
							setEndDate={setEndDate}
							startDate={startDate}
							disable={!startDate || disableFilters}
						/>
					</div>
				</div>
				<div className="overview_filter__col">
					<div className="overview_filter__col__top">Status</div>
					<div className="overview_filter__col__bottom">
						<MultiSelectCheckbox
							items={statusOptions}
							onChangeFunc={setStatusOptions}
							disable={disableFilters}
						/>
					</div>
				</div>
				<div className="overview_filter__col">
					<div className="overview_filter__col__top">
						{/* Status */}
						&nbsp;
					</div>
					<div className="overview_filter__col__bottom overview_filter__col__title--heavy overview_filter__col__bottom--padding-top-bottom">
						<span
							className="link link--color"
							onClick={resetFilter}
						>
							Clear filters
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};
MultiSelectFilter.propTypes = {
	filterConfig: PropTypes.array.isRequired,
	statusOptions: PropTypes.array.isRequired,
	setStatusOptions: PropTypes.func.isRequired,
	startDate: PropTypes.instanceOf(Date),
	setStartDate: PropTypes.func.isRequired,
	endDate: PropTypes.instanceOf(Date),
	setEndDate: PropTypes.func.isRequired,
	resetFilter: PropTypes.func.isRequired,
	disableFilters: PropTypes.bool.isRequired,
};
export default MultiSelectFilter;
